import { socketService } from '@aqx-core/common/socket';

import { IPublicMessage } from '../topics/public';

class PublicTopicSubscription {
  public subscribe = (tenantId: string, receiver: (payload: IPublicMessage | undefined) => void) => {
    socketService.topics().public.subscribe({
      tenantId,
      receiver: (payload) => receiver(payload)
    });
  };

  public unsubscribe = (tenantId: string, receiver: (payload: IPublicMessage | undefined) => void) => {
    socketService.topics().public.unsubscribe({
      tenantId,
      receiver: (payload) => receiver(payload)
    });
  };
}

export const publicTopicSubscription = new PublicTopicSubscription();
